import * as $ from 'jquery';
export const authPopup = ()=>{

    const closeAuthPopup = $('.close-popup-btn-js');
    const authPopup = $('.auth-popup-js');
    const authForms = $('.auth-form-js');
    const signUpForm = $('#signup_form');
    const loginForm = $('#login_form');
    const forgotPasswordForm = $('#forgot_password_form');
    const resendEmailForm = $('#resend_email_form');

    const desktopMQ = window.matchMedia('(min-width: 1200px)');
    let isDesktop = desktopMQ.matches;
    desktopMQ.addEventListener('change', (e) => {
        isDesktop = e.matches;
    });

    closeAuthPopup.on('click',function(){
        authPopup.addClass('hidden');
        authForms.addClass('hidden');
        forgotPasswordForm.addClass('hidden');
        resendEmailForm.addClass('hidden');
        if (isDesktop) {
            $('body').removeClass('shadow');
        }
    });

    $('.switch-to-signup-js').on('click',function(){
        loginForm.addClass('hidden');
        signUpForm.removeClass('hidden');
    });

    $('.switch-to-login-js').on('click',function(){
        signUpForm.addClass('hidden');
        loginForm.removeClass('hidden');
    });



    $('.login-js').on('click',function(){
        authPopup.removeClass('hidden');
        $('body').addClass('shadow');
        authForms.addClass('hidden');
        $('#login_form').removeClass('hidden');
    });

    $('.signup-js').on('click',function(){
        authPopup.removeClass('hidden');
        $('body').addClass('shadow');
        authForms.addClass('hidden');
        signUpForm.removeClass('hidden');
    });
}